export const es = {
  "login_for_quick_quote": "Fácil, rápido, seguro.",
  "origin": "Origen",
  "destination": "Destino (Ciudad)",
  "payment_details": "Detalles de pago",
  "postal_code": "Código Postal USA",
  "for": "Para",
  "enter_city_final_destination": "Ingrese ciudad de destino final",
  "continue": "Continuar",
  "close_session": "Cerrar sesión",
  "english": "Inglés",
  "spanish": "Español",
  "large": "Largo",
  "dimensions": "Dimensiones",
  "length": "Largo",
  "high": "Alto",
  "width": "Ancho",
  "weight": "Peso",
  "declared_value": "Valor declarado",
  "cancel": "Cancelar",
  "tell_us_more_about_your_shipment": "Cuéntanos más sobre tu envío",
  "inches_or_centimeters": "Pulgadas o centímetros",
  "pounds_or_kilograms": "Libras o kilogramos",
  "use_the_format_you_need": "Utiliza el formato que necesites",
  "if_you_have_questions": "Si tienes preguntas",
  "measurement_guide": "Tamaños y pesos frecuentes",
  "box_size": "Tamaño de la caja",
  "envelope": "Sobre",
  "small_box": "Caja pequeña",
  "medium_box": "Caja mediana",
  "large_box": "Caja grande",
  "centimeters": "Centímetros",
  "inches": "Pulgadas",
  "payment_method": "Método de pago",
  "use": "Uso",
  "sender_name": "Nombre del remitente",
  "phone_number": "Número de WhatsApp",
  "address": "Dirección",
  "instructions": "Instrucciones",
  "save": "Guardar y continuar",
  "contact_us": "Contáctanos",
  "destination_name": "Nombre del destinatario",
  "remitent_name": "Nombre del remitente",
  "neighborhood": "Barrio",
  "Indications": "Indicaciones",
  "return": "Regresar",
  "add_address": "Agregar dirección",
  "loading": "Cargando...",
  "edit_measures": "Editar medidas",
  "delivery_options": "Escoge la velocidad de tu envío",
  "day": "Día",
  "days": "Días",
  "unexpected_error_message": "Ocurrió un error inesperado, inténtalo de nuevo",
  "fee_change": "Cambio de tarifa",
  "login_register_seconds": "Inicia sesión para una cotización rápida.",
  "to_qoute_shipment": "Para cotizar tu envío",
  "login_methods": "El Login con redes sociales pronto estará disponible.",
  "forget_password": "Olvidé mi clave",
  "password": "Contraseña",
  "login": "Iniciar sesión",
  "sing_up": "Registrate",
  "or": "o",
  "logout": "Cerrar sesión",
  "measurementGuide": "Tamaños y pesos frecuentes",
  "paper_envelope": "Sobre de papel",
  "inch": "Pulgadas",
  "broad": "Ancho",
  "long": "Largo",
  "max_largebox": "(máx 80lbs o 40kg)",
  "medium_box_max": "(máx 50lbs o 25kg)",
  "small_box_max": "(máx 25lbs o 13kg)",
  "pay_with_credit_card": "Pagar con tarjeta de crédito",
  "pay_with_zelle": "Pagar con Zelle",
  "pay": "Pagar",
  "delivery_summary": "Resumen del envío",
  "remitent_data": "Datos del remitente en USA.",
  "destination_data": "Datos del destinatario en Colombia",
  "tell_more_about_us": "Cuéntanos más sobre tu envío.",
  "please_enter_the_size": "Por favor, ingrese el tamaño y peso del envío. Puedes usar pulgadas o centímetros para las dimensiones y libras o kilogramos para el peso. Usa el formato que necesites.",
  "measurement_format": "Formato de medida",
  "value_of_the_merchandise": "Valor de la mercancía",
  "there_are_an_error": "Hubo un error",
  "success_payment": "Pago exitoso",
  "remitent": "Remitente",
  "download_guide": "Descargar guía",
  "whats_next": "¿Qué sigue ahora?",
  "important_note": "NOTA IMPORTANTE: ",
  "the_zelle_services": "El servicio de Zelle permite enviar dinero utilizando un correo electrónico. Preferimos esta opción ya que minimiza la posibilidad de enviar el pago a un número equivocado.",
  "zelle_indiacions_1": "Por favor, copia y pega el siguiente correo electrónico en la aplicación de Zelle tal como se muestra para evitar retrasos:",
  "just_reference": "Solo para tu referencia: El nombre registrado es ",
  "advanced_consulting_business": "Advanced Consulting Business.",
  "contact_by_whatsapp": "Después de realizar el pago, contáctanos a través de nuestro WhatsApp:",
  "in_order_to_send_guide": "para enviarte tu guía, la cual debe ir forrada en cinta transparente.",
  "last_step": "Último paso:",
  "delivery_your_box": "Entrega tu caja a la transportadora correspondiente.",
  "warning": "Advertencia:",
  "box_that_are_more_than": "Las cajas que pesen más de 40 libras (20 kilogramos) deben estar forradas en plástico o cinta para evitar que se abran en algún borde.",
  "From": " Desde (Estado)",
  "to": "Destino",
  "shipping_around_usa": "Envío dentro de los USA.",
  "shipping_from": "Envío internacional desde Florida",
  "tax": "Valor impuestos aduana",
  "delivery_time": "Tiempo de entrega (Días hábiles)",
  "provider": "Proveedor dentro de USA.",
  "Total": "Total",
  "cost_of_shiping": "Costo de envío",
  "insurance_and_taxes":"Impuestos y seguro",
  "freight":"Fletes",
  "incorrect_password":"Tu cuenta existe pero tu contraseña es incorrecta. Usa la misma clave que pones en app.latamshipping.com.",
  "origen_destino":"Origen & Destino",
  "cost":"Costo",
  "print_your_guide":"Imprime tu guía y asegúrate que esté completamente forrada con cinta plástica. Luego, entrega tu caja a la transportadora correspondiente.",
  'deliver_your_box_to':'Entregar a:',
  'no_result': 'No se encontraron resultados',
  "adress_data_error": "Uno o más campos de la nueva dirección no son correctos, inténtelo de nuevo",
  "city": "Ciudad",
  "select": "Seleccione",
  "cheapest": "Más barato",
};